/** @jsxImportSource @emotion/react */
import React from "react";
import { Spinner } from "../../../Spinner/Spinner";
import { css } from "@emotion/react";
import { approvalSpinnerWrapper } from "../../../../config/commonCSS";
import { Text } from "../../../general/Text";

export const ConfirmInWallet: React.FC<{ isVisible: boolean; confirmOrApproveText: string }> = ({
  isVisible,
  confirmOrApproveText,
}) => {
  if (!isVisible) {
    return null;
  }
  return (
    <div
      css={css`
        display: flex;
        height: 40px;
        align-items: center;
        margin: 0 auto;
      `}
    >
      <div css={approvalSpinnerWrapper}>
        <Spinner />
      </div>
      <Text textStyle="Paragraph" size="Large">
        {confirmOrApproveText} in wallet
      </Text>
    </div>
  );
};
